import { InfoOutlined } from '@mui/icons-material';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';

export default function DataCollectionInformation() {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: theme.spacing(1),
          alignItems: 'center',
          padding: theme.spacing(1),
          border: `1px solid ${theme.colors.primary.dark}`,
          borderRadius: theme.spacing(1),
          backgroundColor: theme.colors.primary.light
        }}
      >
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: theme.spacing(1),
            padding: '4px 8px 0px 8px'
          }}
        >
          <InfoOutlined color="primary" />
        </Box>
        <Stack spacing={1}>
          <Typography variant="h4">
            {t('data collection information')}
          </Typography>
          <Typography variant="caption">
            {t(
              'when you add this object, the system will retrieve up to 14 days of historical data available in our database. once the object is ready, the system will automatically continue collecting new data going forward.'
            )}
          </Typography>
        </Stack>
      </Box>
    </>
  );
}
